export enum DocumentDetailsStatus {
    Viewable,
    RequiresAction,
    Completed,
}

export const DocumentDetailsStatusOptions = {
    [DocumentDetailsStatus.Viewable]: 'Viewable',
    [DocumentDetailsStatus.RequiresAction]: 'Requires Action',
    [DocumentDetailsStatus.Completed]: 'Completed',
};